import LabelValue from './LabelValue';

export default LabelValue;
